import { module } from 'modujs';
import Swiper, { Pagination } from "swiper";
import { lazyLoadImage } from '../utils/image';
import { queryClosestParent } from '../utils/html';

export default class extends module {
    constructor(m) {
        super(m);

        // Data
        this.recommendationsUrl = this.getData('url')

        // Binding
        this.onFocusBind = this.onFocus.bind(this)
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() { }

    destroy() {
        super.destroy();
        this.carousel?.destroy?.(true, true)
        this.unbindEvents()
    }

    ///////////////
    // Methods
    ///////////////
    getRecommendations() {
        // Load indicator
        this.el.classList.add('is-loading');

        // Fetch
        fetch(this.recommendationsUrl)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const $recommendations = html.querySelector('.c-product-recommendations');
                const $productTiles = $recommendations.querySelectorAll('.c-product-tile');
                const hasArticles = $productTiles.length > 0

                if (hasArticles && $recommendations.innerHTML.trim().length) {
                    this.el.innerHTML = $recommendations.innerHTML;

                    requestAnimationFrame(() => {
                        this.initCarousel()
                    })
                } else {
                    // Load indicator
                    this.el.classList.remove('is-loading');

                    setTimeout(() => {
                        this.el.classList.add('is-empty');
                    }, 600)
                }
            })
            .catch(e => {
                // Load indicator
                this.el.classList.remove('is-loading');
                console.error(e);
            });

    }

    initCarousel() {

        // Selectors
        const $carousel = this.el.querySelector('.swiper-container')
        this.$wrapper = this.el.querySelector('.swiper-wrapper')
        this.$links = this.el.querySelectorAll('[data-index]')
        this.$section = queryClosestParent($carousel, '.js-carousel-section');
        
        // Events
        this.bindEvents()

        // Swiper options
        Swiper.use([Pagination])

        // Swiper instance
        this.carousel = new Swiper($carousel, {
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            threshold: 3,
            breakpoints: {
                700: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 40,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    }
                }
            },
            on: {
                init: () => {
                    // Load indicator
                    this.el.classList.remove('is-loading');

                    // Load images
                    this.loadImages()
                },
            },
        })
    }

    loadImages() {
        const $images = this.el.querySelectorAll('img')
        let imageIndex = 0

        while (imageIndex < $images.length) {
            const $image = $images[imageIndex]
            lazyLoadImage($image)
            imageIndex++
        }
    }

    bindEvents() {
        for (let index = 0; index < this.$links.length; index++) {
            const $link = this.$links[index];
            $link.addEventListener('focus', this.onFocusBind)
        }
    }

    unbindEvents() {
        for (let index = 0; index < this.$links.length; index++) {
            const $link = this.$links[index];
            $link.removeEventListener('focus', this.onFocusBind)
        }
    }

    onFocus(e) {
        const index = e.target.dataset.index
        this.$section.scrollLeft = 0
        this.carousel.slideTo(index)
    }
}